// src/components/Admin/AccessDenied.js
import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FaExclamationTriangle, FaHome, FaEnvelope } from 'react-icons/fa';
import './Admin.css';

const AccessDenied = ({ error }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className="admin-error-page">
            <Container>
                <div className="admin-error-container">
                    <div className="admin-error-content">
                        <div className="admin-error-icon">
                            <FaExclamationTriangle />
                        </div>
                        <h2 className="admin-error-title">{t('adminDashboard.accessDenied')}</h2>
                        <p className="admin-error-message">{t('adminDashboard.noAdminPrivileges')}</p>
                        <div className="admin-error-detail">
                            <span className="admin-error-label">{t('adminDashboard.errorLabel')}:</span>
                            <span className="admin-error-code">
                {error || t('adminDashboard.requestFailed')} (403)
              </span>
                        </div>
                        <p className="admin-error-help">{t('adminDashboard.contactAdmin')}</p>
                        <div className="admin-error-actions">
                            <Button
                                variant="primary"
                                size="lg"
                                className="admin-error-button"
                                onClick={() => navigate('/')}
                            >
                                <FaHome className="admin-button-icon" />
                                {t('adminDashboard.returnHome')}
                            </Button>
                            <Button
                                variant="outline-secondary"
                                size="lg"
                                className="admin-error-button"
                                href="mailto:admin@example.com"
                            >
                                <FaEnvelope className="admin-button-icon" />
                                {t('adminDashboard.contactSupport')}
                            </Button>
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default AccessDenied;